import { ModuleSidebar } from "@/components/modules/ModuleSidebar";
import { MODULES } from "@/lib/modules/registry";

export function TribunaisSidebar() {
  return <ModuleSidebar config={MODULES.tribunais} />;
}
